import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ContextService, Typology } from '@bcef/ia-shared';
import { InfoClientService } from '@bcef/ia-shared/info-client';
import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';

import { Civility } from '@core/enums/civility.enum';
import { ContactInfo, EMPTY_CONTACT_INFO } from '@core/models/contact-info.model';

export interface ContactState {
  contact: ContactInfo;
}

export const INITIAL_CONTACT_STATE: ContactState = {
  contact: EMPTY_CONTACT_INFO,
};

export function withContact() {
  return signalStoreFeature(
    withState<ContactState>(INITIAL_CONTACT_STATE),
    withMethods(
      (store, infoClient = inject(InfoClientService), context = inject(ContextService)) => ({
        saveContact: (contact: ContactInfo): void => patchState(store, { contact }),
        setEmail: (email: string): void =>
          patchState(store, (state) => ({
            contact: { ...state.contact, email },
          })),
        setClientType: (): void =>
          patchState(store, (state) => ({
            contact: {
              ...state.contact,
              clientType: context.isNhb ? Typology.HB : context.typology,
            },
          })),
        setClientInformation: (): void => {
          const clientData = toSignal(infoClient.getInfoClient());
          const client = clientData()?.data.client;
          if (client) {
            patchState(store, (state) => ({
              contact: {
                ...state.contact,
                lastName: client.nomComplet,
                firstName: client.prenom,
                civility: client.civilite === 1 ? Civility.Mr : Civility.Mrs,
              },
            }));
          }
        },
      }),
    ),
  );
}
